<template>
  <layout-general v-if="modalVisible === 'code'" @close="modalClose()">
    <h4 class="modal-title" slot="header">{{ $t('general.actions.export') }} box</h4>
    <div slot="body">
      <div>
        <h4 class="help-block">{{ $t('modal.code.step_one') }}</h4>
        <textarea readonly class="code-textarea" @click="$event.target.select()">{{ codeScript }}</textarea>
        <copy-button :text="codeScript"></copy-button>
      </div>
      <div v-if="showButtonAttribute()">
        <h4 class="help-block">{{ $t('modal.code.step_two') }} {{ $t('modal.code.step_three') }}</h4>
        <textarea readonly class="code-textarea" @click="$event.target.select()">{{ codeButtonAttribute }}</textarea>
        <copy-button :text="codeButtonAttribute"></copy-button>
      </div>
    </div>
  </layout-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LayoutGeneral from './layout/General.vue';
import CopyButton from '../general/CopyButton.vue';
import autosize from 'autosize';

export default {
  components: {
    LayoutGeneral,
    CopyButton,
  },
  computed: mapGetters({
    modalVisible: 'modalVisible',
    box: 'codeBox',
    codeScript: 'codeScript',
    codeButtonAttribute: 'codeButtonAttribute',
  }),
  methods: {
    ...mapActions([
      'modalClose',
    ]),
    showButtonAttribute() {
      return this.box.kind !== 'component' && this.box.config.trigger_button.kind === 'external';
    },
  },
  mounted() {
    if (this.$el && this.$el.querySelectorAll) {
      autosize(this.$el.querySelectorAll('textarea'));
    }
  },
  updated() {
    if (this.$el && this.$el.querySelectorAll) {
      autosize(this.$el.querySelectorAll('textarea'));
    }
  },
};
</script>



/** WEBPACK FOOTER **
 ** Code.vue?051cc5b8
 **/